import Button from '@tencent/txv-athena/button';
import tips from '@tencent/txv-athena/tips';
import RoleSelectDialog from '@tencent/txv-athena/role-select-dialog';
import { EventHub } from '@tencent/txv-utils';

export const roleSelectDialog = ({ gameId }) => {
  const dialog = new RoleSelectDialog('#app', {
    gameId,
  });
  const eventHub = EventHub.createEvents(dialog);
  const button = new Button(dialog.$footer, {
    text: '确定',
  });
  button.on('button-click', () => {
    const { selectRole = {}, selectServer = {}, selectZone = {} } = dialog.zoneSelect;
    if (!selectRole.roleId) {
      tips({ text: '未选择角色' });

      return;
    }
    eventHub.fire('confirm', {
      selectRole,
      selectServer,
      selectZone,
    });
  });

  return dialog;
};
